<template>
  <q-layout view="hHh LpR fFf">
    <!-- header -->
    <q-header
      v-if="route.meta.noAuth && route.name != 'Login'"
      class="bg-white my-font"
    >
      <div
        v-if="!isMobile && !isTablet"
        class="l-grow bg-white row justify-between q-px-xl q-py-sm text-grey-5"
        style="font-size: 12px"
      >
        <div class="items-center row q-gutter-x-sm">
          <q-icon name="watch_later" size="18px" color="grey-10" />
          <span>{{ $t("header.hours") }}</span>
        </div>
        <div class="row q-gutter-x-lg">
          <div class="items-center row q-gutter-x-sm">
            <q-icon name="phone" size="18px" color="grey-10" />
            <span>(021) 5937 1878</span>
          </div>
          <div class="items-center row q-gutter-x-sm">
            <q-icon name="email" size="18px" color="grey-10" />
            <span>general@ligno.co.id</span>
          </div>
        </div>
      </div>
      <!-- <q-separator v-if="!isMobile && !isTablet" class="bg-red" size="2px" /> -->
      <q-toolbar class="q-py-sm" :class="isMobile || isTablet ? '' : 'q-px-xl'">
        <q-img
          :src="`./img/ligno.png`"
          height="48px"
          width="138px"
          fit="contain"
          @click="
            router.push('/');
            data.tab = null;
          "
          class="cursor-pointer"
        ></q-img>
        <q-space></q-space>
        <q-tabs
          v-if="!isMobile && !isTablet"
          v-model="data.tab"
          active-color="primary"
          class="header-tabs text-black q-gutter-x-md row"
          no-caps
        >
          <q-route-tab name="home" :label="$t('nav.home')" to="/" />
          <q-route-tab name="profile" :label="$t('nav.profile')" to="/profile" />
          <div
            :style="
              route.name == 'concrete' || route.name == 'mine'
                ? 'border-bottom:  2px solid #027be3'
                : 'border-bottom:  2px solid white'
            "
            class="q-ma-none column justify-center"
            style="height: 100%; padding-top: 2px"
          >
            <q-btn-dropdown
              :label="$t('nav.products')"
              v-model="menuProduk"
              dropdown-icon="keyboard_arrow_down"
              flat
              :color="
                route.name == 'concrete' || route.name == 'mine'
                  ? 'primary'
                  : 'black'
              "
              no-caps
              auto-close
              stretch
              class="q-ma-none"
            >
              <q-list style="width: 150px">
                <q-item clickable v-close-popup to="/concrete">
                  <q-item-section>
                    <q-img
                      :src="`./img/menu_produk1.png`"
                      height="32px"
                      fit="contain"
                    ></q-img>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ $t("nav.concrete") }}</q-item-label>
                  </q-item-section>
                </q-item>
                <q-item clickable v-close-popup to="/mine">
                  <q-item-section>
                    <q-img
                      :src="`./img/menu_produk2.png`"
                      height="32px"
                      fit="contain"
                    ></q-img>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ $t("nav.mine") }}</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
          </div>

          <div
            :style="
              route.name == 'article' ||
              route.name == 'articleDetail' ||
              route.name == 'gallery' ||
              route.name == 'news' ||
              route.name == 'newsDetail'
                ? 'border-bottom:  2px solid #027be3'
                : 'border-bottom:  2px solid white'
            "
            class="q-ma-none column justify-center"
            style="height: 100%; padding-top: 2px"
          >
            <q-btn-dropdown
              :label="$t('nav.media')"
              v-model="menuMedia"
              dropdown-icon="keyboard_arrow_down"
              flat
              :color="
                route.name == 'article' ||
                route.name == 'articleDetail' ||
                route.name == 'gallery' ||
                route.name == 'news' ||
                route.name == 'newsDetail'
                  ? 'primary'
                  : 'black'
              "
              no-caps
              class="q-ma-none"
              auto-close
              stretch
            >
              <q-list style="width: 150px">
                <q-item clickable v-close-popup to="/gallery">
                  <q-item-section>
                    <q-img
                      :src="`./img/menu_gambar.png`"
                      height="32px"
                      fit="contain"
                    ></q-img>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ $t("nav.gallery") }}</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/article">
                  <q-item-section>
                    <q-img
                      :src="`./img/menu_artikel.png`"
                      height="32px"
                      fit="contain"
                    ></q-img>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ $t("nav.article") }}</q-item-label>
                  </q-item-section>
                </q-item>

                <q-item clickable v-close-popup to="/news">
                  <q-item-section>
                    <q-img
                      :src="`./img/menu_berita.png`"
                      height="32px"
                      fit="contain"
                    ></q-img>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>{{ $t("nav.news") }}</q-item-label>
                  </q-item-section>
                </q-item>
              </q-list>
            </q-btn-dropdown>
          </div>

          <q-route-tab name="faq" :label="$t('nav.faq')" to="/faq" />
        </q-tabs>

        <q-space></q-space>
        <div v-if="!isMobile && !isTablet" class="row items-center">
          <q-btn-dropdown
            outline
            rounded
            no-caps
            class="text-black"
            dropdown-icon="keyboard_arrow_down"
          >
            <template v-slot:label>
              <span
                class="flag-circle"
                :class="locale === 'en' ? 'flag-en' : 'flag-id'"
              ></span>
              <span class="q-ml-sm text-bold">{{
                locale === "en" ? "EN" : "ID"
              }}</span>
            </template>
            <q-list dense style="min-width: 180px">
              <q-item
                clickable
                v-close-popup
                :active="locale === 'id'"
                @click="setLang('id')"
              >
                <q-item-section side>
                  <span class="flag-circle flag-id"></span>
                </q-item-section>
                <q-item-section>Bahasa Indonesia</q-item-section>
              </q-item>
              <q-item
                clickable
                v-close-popup
                :active="locale === 'en'"
                @click="setLang('en')"
              >
                <q-item-section side>
                  <span class="flag-circle flag-en"></span>
                </q-item-section>
                <q-item-section>English</q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </div>

        <!-- Mobile Menu -->
        <q-btn
          v-if="isMobile || isTablet"
          flat
          round
          icon="menu"
          color="black"
          @click="leftDrawerOpen = true"
        />
      </q-toolbar>
      <!-- Drawer for Mobile Navigation -->
      <q-drawer
        v-model="leftDrawerOpen"
        side="left"
        overlay
        behavior="mobile"
        class="bg-white column"
        style="height: 100%; width: 100vw !important"
      >
        <!-- Drawer Header -->
        <div class="q-px-md q-py-sm row items-center justify-end">
          <!-- <q-img
            :src="`./img/ligno.png`"
            height="40px"
            width="115px"
            fit="contain"
            alt="Logo"
          /> -->
          <q-btn
            flat
            round
            icon="close"
            color="black"
            @click="leftDrawerOpen = false"
          />
        </div>
        <q-separator class="bg-red" size="3px" />

        <!-- Search Bar -->
        <!-- <div>
          <q-input
            v-model="data.search"
            rounded
            outlined
            dense
            placeholder="Pencarian"
            style="max-width: 1000px"
            class="l-grow q-pa-sm"
            bg-color="grey-1"
          >
            <template v-slot:append>
              <q-icon color="grey" name="search" />
            </template>
          </q-input>
        </div> -->
        <div>
          <!-- Menu Items -->
          <q-list class="text-black">
            <q-item clickable v-ripple v-close-popup to="/">
              <q-item-section>{{ $t("nav.home") }}</q-item-section>
            </q-item>

            <q-item clickable v-ripple v-close-popup to="/profile">
              <q-item-section>{{ $t("nav.profile") }}</q-item-section>
            </q-item>

            <!-- Produk Section with Submenus -->
            <q-expansion-item :label="$t('nav.products')" dense>
              <q-item clickable v-ripple v-close-popup to="/concrete">
                <q-item-section avatar>
                  <q-img
                    :src="`./img/menu_produk1.png`"
                    height="32px"
                    fit="contain"
                  ></q-img>
                </q-item-section>
                <q-item-section>{{ $t("nav.concrete") }}</q-item-section>
              </q-item>
              <q-item clickable v-ripple v-close-popup to="/mine">
                <q-item-section avatar>
                  <q-img
                    :src="`./img/menu_produk2.png`"
                    height="32px"
                    fit="contain"
                  ></q-img>
                </q-item-section>
                <q-item-section>{{ $t("nav.mine") }}</q-item-section>
              </q-item>
            </q-expansion-item>

            <!-- Media Section with Submenus -->
            <q-expansion-item class="q-pt-sm" :label="$t('nav.media')" dense>
              <q-item clickable v-ripple v-close-popup to="/gallery">
                <q-item-section avatar>
                  <q-img
                    :src="`./img/menu_gambar.png`"
                    height="32px"
                    fit="contain"
                  ></q-img>
                </q-item-section>
                <q-item-section>{{ $t("nav.gallery") }}</q-item-section>
              </q-item>
              <q-item clickable v-ripple v-close-popup to="/article">
                <q-item-section avatar>
                  <q-img
                    :src="`./img/menu_artikel.png`"
                    height="32px"
                    fit="contain"
                  ></q-img>
                </q-item-section>
                <q-item-section>{{ $t("nav.article") }}</q-item-section>
              </q-item>
              <q-item clickable v-ripple v-close-popup to="/news">
                <q-item-section avatar>
                  <q-img
                    :src="`./img/menu_berita.png`"
                    height="32px"
                    fit="contain"
                  ></q-img>
                </q-item-section>
                <q-item-section>{{ $t("nav.news") }}</q-item-section>
              </q-item>
            </q-expansion-item>

            <q-item clickable v-ripple v-close-popup to="/faq">
              <q-item-section>{{ $t("nav.faq") }}</q-item-section>
            </q-item>
          </q-list>

          <!-- Language switch (mobile) -->
          <q-separator class="q-my-sm" />
          <div class="q-px-md q-py-sm row items-center q-gutter-x-sm">
            <q-btn
              dense
              no-caps
              unelevated
              :outline="locale !== 'id'"
              :color="locale === 'id' ? 'primary' : 'grey-7'"
              padding="4px 12px"
              @click="setLang('id')"
            >
              <span class="flag-circle flag-id q-mr-sm"></span>
              Bahasa Indonesia
            </q-btn>
            <q-btn
              dense
              no-caps
              unelevated
              :outline="locale !== 'en'"
              :color="locale === 'en' ? 'primary' : 'grey-7'"
              padding="4px 12px"
              @click="setLang('en')"
            >
              <span class="flag-circle flag-en q-mr-sm"></span>
              English
            </q-btn>
          </div>
        </div>

        <q-space />
        <!-- Hubungi Kami Button -->
        <div class="q-pa-md column justify-end">
          <q-btn
            unelevated
            no-caps
            :label="$t('nav.contact')"
            color="primary"
            @click="
              router.push('/contact');
              data.tab = null;
            "
          />
        </div>
      </q-drawer>
      <q-separator v-if="isMobile || isTablet" class="bg-red" size="2px" />
    </q-header>

    <q-header v-if="!route.meta.noAuth" class="bg-white my-font" elevated>
      <q-toolbar class="q-py-xs">
        <q-img
          :src="`./img/ligno.png`"
          height="40px"
          width="115px"
          fit="contain"
          class="cursor-pointer"
        ></q-img>
        <q-space></q-space>
        <div class="row items-center q-gutter-x-sm">
          <q-avatar>
            <img :src="'./avatar.png'" />
          </q-avatar>
          <q-btn-dropdown
            flat
            no-caps
            class="text-black"
            dropdown-icon="keyboard_arrow_down"
            dense
          >
            <template v-slot:label>
              <div class="text-left" v-if="route.meta.user">
                <div class="text-bold">
                  {{ route.meta.user.nama }}
                </div>
                <div class="l-text-thin text-grey-6" style="line-height: 14px">
                  {{ route.meta.user.department }}
                </div>
              </div>
            </template>

            <q-card class="row no-wrap all-radius column" style="width: 250px">
              <q-card-section class="column items-center q-gutter-y-sm">
                <q-avatar size="72px">
                  <img :src="'./avatar.png'" />
                </q-avatar>
                <div class="text-center">
                  <div class="text-bold l-text-detail">
                    {{ route.meta.user.nama }}
                  </div>
                  <div
                    class="l-text-thin text-grey-6"
                    style="line-height: 14px"
                  >
                    {{ route.meta.user.department }}
                  </div>
                </div>
              </q-card-section>

              <q-btn
                dense
                flat
                class="q-px-md q-py-xs"
                icon="lock"
                label="Ubah Sandi"
                no-caps
                align="left"
                @click="showDialogChangePass"
                v-close-popup
              />
              <q-separator size="1px" color="grey-4"></q-separator>
              <q-btn
                dense
                flat
                class="q-px-md q-py-xs"
                icon="logout"
                label="Logout"
                color="negative"
                no-caps
                align="left"
                v-close-popup
                @click="logout"
              />
            </q-card>
          </q-btn-dropdown>
        </div>
      </q-toolbar>
    </q-header>

    <!-- left drawer -->
    <q-drawer
      v-if="route.name != 'Login' && !route.meta.noAuth"
      v-model="CMSDrawerOpen"
      bordered
      class="bg-white"
    >
      <q-list>
        <!-- <q-item
          clickable
          class="inactive-menu"
          :active-class="
            miniState
              ? 'bg-blue-2 text-blue'
              : 'bg-blue-2 text-blue active-menu'
          "
        >
          <q-item-section avatar>
            <q-icon
              :name="`${$route.name == 'Dashboard' ? '' : 'o_'}dashboard`"
            />
          </q-item-section>

          <q-item-section>Dashboard</q-item-section>
        </q-item>
        <q-item
          clickable
          class="inactive-menu"
          :active="$route.name == 'ManageCarousel'"
          :active-class="
            miniState
              ? 'bg-blue-2 text-blue'
              : 'bg-blue-2 text-blue active-menu'
          "
          to="/manage-carousel"
        >
          <q-item-section avatar>
            <q-icon
              :name="`${
                $route.name == 'ManageCarousel' ? '' : 'o_'
              }view_carousel`"
            />
          </q-item-section>

          <q-item-section>Carousel</q-item-section>
        </q-item> -->
        <q-item
          clickable
          class="inactive-menu"
          :active="
            $route.name == 'ManageProductCatalog' ||
            $route.name == 'ManageProductForm'
          "
          :active-class="
            miniState
              ? 'bg-blue-2 text-blue'
              : 'bg-blue-2 text-blue active-menu'
          "
          to="/manage-catalog"
        >
          <q-item-section avatar>
            <q-icon
              :name="`${
                $route.name == 'ManageProductCatalog' ||
                $route.name == 'ManageProductForm'
                  ? ''
                  : 'o_'
              }inventory_2`"
            />
          </q-item-section>

          <q-item-section>Katalog Produk</q-item-section>
        </q-item>
        <q-expansion-item
          class="cursor-pointer"
          :header-class="
            $route.name == 'ManageArticle' ||
            $route.name == 'ManageArticleForm' ||
            $route.name == 'ManageNews' ||
            $route.name == 'ManageNewsForm' ||
            $route.name == 'ManageGallery'
              ? 'bg-blue-2 text-blue active-menu'
              : 'text-black inactive-menu'
          "
          :expand-icon-class="
            $route.name == 'ManageArticle' ||
            $route.name == 'ManageArticleForm' ||
            $route.name == 'ManageNews' ||
            $route.name == 'ManageNewsForm' ||
            $route.name == 'ManageGallery'
              ? 'text-blue'
              : 'text-black'
          "
          default-opened
        >
          <template v-slot:header>
            <q-item-section avatar>
              <q-icon
                :name="`${
                  $route.name == 'ManageArticle' ||
                  $route.name == 'ManageArticleForm' ||
                  $route.name == 'ManageNews' ||
                  $route.name == 'ManageNewsForm' ||
                  $route.name == 'ManageGallery'
                    ? ''
                    : 'o_'
                }perm_media`"
              />
            </q-item-section>
            <q-item-section>
              <q-item-label>Media</q-item-label>
            </q-item-section>
          </template>
          <q-item
            :active="
              $route.name == 'ManageArticle' ||
              $route.name == 'ManageArticleForm'
            "
            active-class="text-blue"
            clickable
            to="/manage-article"
          >
            <q-item-section avatar></q-item-section>

            <q-item-section
              :class="
                $route.name == 'ManageArticle' ||
                $route.name == 'ManageArticleForm'
                  ? 'text-primary'
                  : 'text-black'
              "
              >Artikel</q-item-section
            >
          </q-item>
          <q-item
            :active="
              $route.name == 'ManageNews' || $route.name == 'ManageNewsForm'
            "
            active-class="text-blue"
            clickable
            to="/manage-news"
          >
            <q-item-section avatar></q-item-section>

            <q-item-section
              :class="
                $route.name == 'ManageNews' || $route.name == 'ManageNewsForm'
                  ? 'text-primary'
                  : 'text-black'
              "
              >Berita</q-item-section
            >
          </q-item>
          <q-item
            :active="$route.name == 'ManageGallery'"
            active-class="text-blue"
            to="/manage-gallery"
            clickable
          >
            <q-item-section avatar></q-item-section>

            <q-item-section
              :class="
                $route.name == 'ManageGallery' ? 'text-primary' : 'text-black'
              "
              >Gallery</q-item-section
            >
          </q-item>
        </q-expansion-item>
        <q-item
          clickable
          class="inactive-menu"
          :active-class="
            miniState
              ? 'bg-blue-2 text-blue'
              : 'bg-blue-2 text-blue active-menu'
          "
          to="/manage-consult"
        >
          <q-item-section avatar>
            <q-icon
              :name="`${
                $route.name == 'ManageConsultation' ? '' : 'o_'
              }support_agent`"
            />
          </q-item-section>

          <q-item-section>Konsultasi</q-item-section>
        </q-item>
        <!-- <q-item
          clickable
          class="inactive-menu"
          :active-class="
            miniState
              ? 'bg-blue-2 text-blue'
              : 'bg-blue-2 text-blue active-menu'
          "
        >
          <q-item-section avatar>
            <q-icon
              :name="`${$route.name == 'ManageStory' ? '' : 'o_'}history`"
            />
          </q-item-section>

          <q-item-section>Cerita Ligno</q-item-section>
        </q-item> -->
        <q-item
          clickable
          class="inactive-menu"
          :active="$route.name == 'ManageTestimony'"
          :active-class="
            miniState
              ? 'bg-blue-2 text-blue'
              : 'bg-blue-2 text-blue active-menu'
          "
          to="/manage-testimony"
        >
          <q-item-section avatar>
            <q-icon
              :name="`${
                $route.name == 'ManageTestimony' ? '' : 'o_'
              }thumbs_up_down`"
            />
          </q-item-section>

          <q-item-section>Ulasan</q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <!-- content -->
    <q-page-container>
      <router-view class="q-mx-auto my-font" />

      <!-- info contact -->
      <div
        v-if="ctaRoutes.includes(route.name)"
        class="cta-section my-font"
      >
        <div class="l-mobile-container">
          <div class="cta-banner">
            <div class="cta-banner__text">
              <div class="cta-banner__title text-bold">
                {{ $t("cta.title") }}
              </div>
              <div class="cta-banner__subtitle">
                {{ $t("cta.subtitle") }}
              </div>
              <q-btn
                :label="$t('nav.contact')"
                color="white"
                text-color="primary"
                no-caps
                unelevated
                padding="12px 24px"
                class="cta-banner__btn"
                @click="
                  router.push('/contact');
                  data.tab = null;
                "
              />
            </div>
            <img
              :src="`./img/footer1.webp`"
              class="cta-banner__img"
              alt=""
            />
          </div>
        </div>
      </div>

      <!-- footer global; halaman dengan meta ownFooter (v4/v6) membawa
           footer-nya sendiri -->
      <footer
        v-if="route.meta.noAuth && !route.meta.ownFooter"
        class="site-footer my-font"
      >
        <div class="l-mobile-container site-footer__inner">
          <q-img
            :src="`./img/ligno.png`"
            width="150px"
            fit="contain"
            class="site-footer__logo"
          />

          <div class="site-footer__cols">
            <div class="column site-footer__col">
              <div class="site-footer__label">{{ $t("footer.contactInfo") }}</div>
              <div class="row no-wrap items-start site-footer__contact">
                <q-icon name="place" size="18px" class="site-footer__ic" />
                <span class="site-footer__text">
                  {{ $t("footer.address") }}
                </span>
              </div>
              <div class="row no-wrap items-center site-footer__contact">
                <q-icon name="mail" size="18px" class="site-footer__ic" />
                <a href="mailto:general@ligno.co.id" class="site-footer__link">
                  general@ligno.co.id
                </a>
              </div>
              <div class="row no-wrap items-center site-footer__contact">
                <q-icon name="call" size="18px" class="site-footer__ic" />
                <a href="tel:+622159371878" class="site-footer__link">
                  (021) 5937 1878
                </a>
              </div>
              <div class="row no-wrap items-center site-footer__contact">
                <q-icon name="chat" size="18px" class="site-footer__ic" />
                <a
                  class="site-footer__link cursor-pointer"
                  @click="window.open(data.selectedNumber.link, '_blank')"
                >
                  {{ data.selectedNumber.number }}
                </a>
              </div>
            </div>

            <div class="column site-footer__col">
              <div class="site-footer__label">{{ $t("footer.company") }}</div>
              <router-link to="/profile" class="site-footer__link">
                {{ $t("footer.profile") }}
              </router-link>
              <router-link to="/concrete" class="site-footer__link">
                {{ $t("footer.concreteProducts") }}
              </router-link>
              <router-link to="/mine" class="site-footer__link">
                {{ $t("footer.mineProducts") }}
              </router-link>
              <router-link to="/gallery" class="site-footer__link">
                {{ $t("footer.gallery") }}
              </router-link>
            </div>

            <div class="column site-footer__col">
              <div class="site-footer__label">{{ $t("footer.help") }}</div>
              <router-link to="/faq" class="site-footer__link">
                {{ $t("nav.faq") }}
              </router-link>
              <router-link to="/contact" class="site-footer__link">
                {{ $t("nav.contact") }}
              </router-link>
              <router-link to="/article" class="site-footer__link">
                {{ $t("footer.article") }}
              </router-link>
              <router-link to="/news" class="site-footer__link">
                {{ $t("footer.news") }}
              </router-link>
            </div>

            <div class="column site-footer__col">
              <div class="site-footer__label">{{ $t("footer.follow") }}</div>
              <div class="row items-center site-footer__socials">
                <q-btn dense flat round aria-label="Instagram Ligno">
                  <q-img
                    :src="`./img/instagram.png`"
                    width="24px"
                    fit="contain"
                  />
                </q-btn>
                <q-btn dense flat round aria-label="Twitter Ligno">
                  <q-img
                    :src="`./img/twitter.png`"
                    width="24px"
                    fit="contain"
                  />
                </q-btn>
                <q-btn dense flat round aria-label="Facebook Ligno">
                  <q-img
                    :src="`./img/facebook.png`"
                    width="24px"
                    fit="contain"
                  />
                </q-btn>
                <q-btn
                  dense
                  flat
                  round
                  aria-label="YouTube Ligno"
                  @click="
                    window.open(
                      'https://www.youtube.com/channel/UCjBVG0BYuWix3hBblc9mFPA',
                      '_blank',
                    )
                  "
                >
                  <q-img
                    :src="`./img/youtube.png`"
                    width="24px"
                    fit="contain"
                  />
                </q-btn>
              </div>
              <q-img
                :src="`./img/iso.webp`"
                width="150px"
                fit="contain"
                class="site-footer__cert"
                alt="ISO 9001:2015 Certified"
              />
            </div>
          </div>

          <q-separator class="site-footer__sep" />

          <div class="site-footer__bottom">
            <div class="site-footer__copy">
              ©2024 PT LIGNO SPECIALTY CHEMICALS
            </div>
            <div class="row site-footer__legal">
              <span class="site-footer__link cursor-pointer">
                {{ $t("footer.privacy") }}
              </span>
              <span class="site-footer__link cursor-pointer">
                {{ $t("footer.terms") }}
              </span>
            </div>
          </div>
        </div>
      </footer>
    </q-page-container>
  </q-layout>
</template>
<!-- @click="window.open(data.selectedNumber, '_blank')" -->
<script>
import useBasic from "@/composables/useBasic";
import dialogPassword from "./components/dialogPassword.vue";
import { useI18n } from "vue-i18n";
import { setLocale } from "@/i18n";

export default {
  setup() {
    const { locale } = useI18n();

    let setLang = (lang) => {
      setLocale(lang);
    };

    const {
      ref,
      reactive,
      router,
      route,
      watch,
      onMounted,
      $q,
      computed,
      waitThis,
    } = useBasic();

    let data = reactive({
      search: null,
      tab: null,
      selectedNumber: "",
      WAnumbers: [
        {
          name: "Agung",
          number: "0813 8303 6313",
          link: "https://wa.me/+6281383036313",
        },
        {
          name: "Abdel",
          number: "0858 8535 1646",
          link: "https://wa.me/+6285885351646",
        },
        {
          name: "Dika",
          number: "0813 6968 7403",
          link: "https://wa.me/+6281369687403",
        },
        {
          name: "Farid",
          number: "0896 2826 4826",
          link: "https://wa.me/+6289628264826",
        },
        {
          name: "Widodo",
          number: "0822 9897 2863",
          link: "https://wa.me/+6282298972863",
        },
        {
          name: "Emir",
          number: "0853 1693 3864",
          link: "https://wa.me/+6285316933864",
        },
        {
          name: "Amin",
          number: "0812 7118 0708",
          link: "https://wa.me/+6281271180708",
        },
      ],
    });

    // halaman yang menampilkan CTA banner "info contact" di atas footer
    const ctaRoutes = [
      "home",
      "profile",
      "concrete",
      "mine",
      "article",
      "gallery",
      "news",
      "faq",
    ];

    // Check if the current screen is mobile-sized
    let isMobile = computed(() => $q.screen.width <= 500);

    // Check if the current screen is mobile-sized
    let isTablet = computed(() => $q.screen.width <= 800);

    // let tab = ref(null);

    let isCMS = ref(true);
    // let CMSDrawerOpen = ref(true);

    watch(
      () => route.name, // Watching the route name
      (newRouteName) => {
        // console.log("Route name changed to:", newRouteName);
        if (newRouteName === "contact") {
          data.tab = null;
        }
        if (newRouteName === "home") {
          data.tab = "home";
        }
        // if (
        //   newRouteName == "ManageCarousel" ||
        //   newRouteName == "ManageTestimony" ||
        //   newRouteName == "ManageConsultation" ||
        //   newRouteName == "ManageGallery" ||
        //   newRouteName == "ManageArticle" ||
        //   newRouteName == "ManageArticleForm" ||
        //   newRouteName == "ManageNews" ||
        //   newRouteName == "ManageNewsForm" ||
        //   newRouteName == "ManageProductCatalog" ||
        //   newRouteName == "ManageProductForm"
        // ) {
        //   isCMS.value = true;
        //   CMSDrawerOpen.value = true;
        // } else {
        //   isCMS.value = false;
        //   CMSDrawerOpen.value = false;
        // }
      },
    );

    onMounted(async () => {
      // let token = localStorage.getItem(process.env.VUE_APP_TOKEN_NAME);
      // if (token != null) {
      //   isCMS.value = true;
      //   CMSDrawerOpen.value = true;
      // } else {
      //   isCMS.value = false;
      //   CMSDrawerOpen.value = false;
      // }

      //get WA number (random)
      let randomIndex = Math.floor(Math.random() * data.WAnumbers.length);
      data.selectedNumber = data.WAnumbers[randomIndex];
    });

    // logout CMS
    let logout = () => {
      localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);

      // isCMS.value = false;
      // CMSDrawerOpen.value = false;

      $q.notify({ message: "Logout Berhasil", color: "positive" });
      router.push("/login");
    };

    let showDialogChangePass = () => {
      $q.dialog({
        component: dialogPassword,
      }).onOk(() => {
        waitThis(logout);
      });
    };

    return {
      leftDrawerOpen: ref(false),
      menuProduk: ref(null),
      menuMedia: ref(null),
      isCMS,
      CMSDrawerOpen: ref(true),
      // tab,
      data,
      router,
      route,
      window,
      ctaRoutes,
      isMobile,
      isTablet,
      logout,
      showDialogChangePass,
      locale,
      setLang,
    };
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar.scss";
.w400-to-320 {
  width: 400px !important;
  @media only screen and (max-width: 500px) {
    width: 320px !important;
  }
}

.px-xl-to-md {
  padding: 10px 58px;
  @media only screen and (max-width: 500px) {
    padding: 10px 18px;
  }
}

.pa-xl-to-md {
  padding: 58px;
  @media only screen and (max-width: 500px) {
    padding: 18px;
  }
}

/* footer global */

.site-footer {
  background-color: #1a1d21;
  color: white;
}

.site-footer__inner {
  padding: 56px 58px 0;

  @media only screen and (max-width: 800px) {
    padding: 48px 24px 0;
  }

  @media only screen and (max-width: 500px) {
    padding: 40px 18px 0;
  }
}

.site-footer__logo {
  margin-bottom: 44px;
}

.site-footer__cols {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1fr;
  gap: 40px;
  padding-bottom: 48px;

  @media only screen and (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 36px;
  }

  @media only screen and (max-width: 500px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
}

.site-footer__col {
  gap: 14px;
}

.site-footer__label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #8b93a1;
  margin-bottom: 4px;
}

.site-footer__contact {
  gap: 10px;
}

.site-footer__ic {
  color: $primary;
  flex-shrink: 0;
  margin-top: 2px;
}

.site-footer__text {
  color: #c7ccd4;
  font-size: 14px;
  line-height: 1.6;
  max-width: 280px;
}

.site-footer__link {
  color: #c7ccd4;
  font-size: 14px;
  line-height: 1.6;
  text-decoration: none;
  width: fit-content;
  transition: color 0.2s ease;
}

.site-footer__link:hover {
  color: white;
}

.site-footer__socials {
  gap: 4px;
  margin-left: -8px;
}

.site-footer__cert {
  margin-top: 8px;
  background: white;
  border-radius: 6px;
  padding: 8px;
  width: fit-content;
}

.site-footer__sep {
  background-color: rgba(255, 255, 255, 0.12);
}

.site-footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 24px 0;
  color: #8b93a1;
  font-size: 13px;
}

.site-footer__legal {
  gap: 24px;
}

.background-container {
  /* height: 900px; */
  position: relative;
  background-image: url("@/assets/storage.webp");
  background-size: cover;
  background-position: center;
}

/* CTA banner (info contact) */

/* section terbagi 2: putih di atas, hitam (warna footer) di bawah,
   banner biru duduk di garis batas keduanya */
.cta-section {
  position: relative;
  padding: 72px 58px 0;
  background: linear-gradient(
    to bottom,
    #ffffff 0%,
    #ffffff 72%,
    #1a1d21 72%,
    #1a1d21 100%
  );

  @media only screen and (max-width: 700px) {
    padding: 48px 18px 0;
  }
}

.cta-banner {
  position: relative;
  /* tanpa overflow hidden supaya foto pekerja bisa meluber ke atas banner */
  min-height: 300px;
  display: flex;
  align-items: center;

  @media only screen and (max-width: 700px) {
    min-height: 0;
  }
}

/* lapisan background: foto gudang di-fade biru.
   Fade menebal dari kiri ke kanan; mulai 67% jadi biru solid
   sehingga foto tidak terlihat lagi di sepertiga terakhir. */
.cta-banner::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(
      90deg,
      rgba(21, 101, 216, 0.35) 0%,
      rgba(21, 101, 216, 0.6) 30%,
      rgba(21, 101, 216, 0.85) 50%,
      rgba(21, 101, 216, 1) 67%,
      rgba(21, 101, 216, 1) 100%
    ),
    url("@/assets/storage.webp");
  background-size: 100% 100%, cover;
  background-position: center, center;
  background-repeat: no-repeat, no-repeat;
}

/* motif kotak-kotak putih, hanya di area kanan (persis di belakang
   foto pekerja); memudar ke kiri supaya menyatu dgn area foto gudang */
.cta-banner::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 45%;
  z-index: 1;
  pointer-events: none;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.16) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.16) 1px, transparent 1px);
  background-size: 46px 46px, 46px 46px;
  -webkit-mask-image: linear-gradient(
    90deg,
    transparent 0%,
    #000 22%,
    #000 100%
  );
  mask-image: linear-gradient(90deg, transparent 0%, #000 22%, #000 100%);

  @media only screen and (max-width: 700px) {
    display: none;
  }
}

.cta-banner__text {
  position: relative;
  z-index: 2;
  color: white;
  max-width: 620px;
  padding: 56px 64px;

  @media only screen and (max-width: 900px) {
    padding: 48px;
    max-width: 70%;
  }

  @media only screen and (max-width: 700px) {
    max-width: 100%;
    padding: 40px 28px;
  }
}

.cta-banner__title {
  font-size: 34px;
  line-height: 1.25;
  margin-bottom: 14px;

  @media only screen and (max-width: 900px) {
    font-size: 28px;
  }

  @media only screen and (max-width: 500px) {
    font-size: 24px;
  }
}

.cta-banner__subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 28px;

  @media only screen and (max-width: 500px) {
    font-size: 14px;
  }
}

.cta-banner__btn {
  border-radius: 2px;
  font-weight: 700;
}

/* foto pekerja: menempel di dasar banner, bagian atas meluber keluar */
.cta-banner__img {
  position: absolute;
  right: 8%;
  bottom: 0;
  height: 128%;
  width: auto;
  object-fit: contain;
  object-position: bottom;
  z-index: 2;
  pointer-events: none;

  @media only screen and (max-width: 900px) {
    right: 0;
    height: 112%;
    opacity: 0.9;
  }

  @media only screen and (max-width: 700px) {
    display: none;
  }
}

.l-container {
  max-width: 1440px !important;
}

.l-mobile-container {
  max-width: 1440px;
  min-width: 300px;

  margin: 0 auto;
}

.l-grow {
  flex-grow: 99 !important;
}

/* header nav */
.header-tabs .q-tab__label,
.header-tabs .q-btn__content > span {
  font-size: 15px;
}

/* header language pill */
.lang-pill {
}

.lang-pill .q-btn-dropdown__arrow {
  color: #9e9e9e;
}

.flag-circle {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.flag-id {
  background: linear-gradient(to bottom, #ed1c24 50%, #ffffff 50%);
}

.flag-en {
  background: linear-gradient(
      to bottom,
      transparent 44%,
      #c8102e 44%,
      #c8102e 56%,
      transparent 56%
    ),
    linear-gradient(
      to right,
      transparent 44%,
      #c8102e 44%,
      #c8102e 56%,
      transparent 56%
    ),
    linear-gradient(
      to bottom,
      transparent 36%,
      #ffffff 36%,
      #ffffff 64%,
      transparent 64%
    ),
    linear-gradient(
      to right,
      transparent 36%,
      #ffffff 36%,
      #ffffff 64%,
      transparent 64%
    ),
    #012169;
}

.kiri-radius {
  border: 1px solid #bbbbbb;
  border-radius: 8px 0 0 8px !important;
}

.kanan-radius {
  border: 1px solid #bbbbbb;
  border-radius: 0 8px 8px 0 !important;
}
.atas-radius {
  border: 1px solid #bbbbbb;
  border-radius: 8px 8px 0 0 !important;
}
.bawah-radius {
  border: 1px solid #bbbbbb;
  border-radius: 0 0 8px 8px !important;
}

.all-radius {
  border: 1px solid #bbbbbb;
  border-radius: 8px 8px 8px 8px !important;
}

@font-face {
  font-family: customfont;
  src: url(./styles/fonts/Montserrat-Regular.ttf);
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Montserrat-Bold.ttf");
  font-weight: 700;
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Montserrat-SemiBold.ttf");
  font-weight: 500;
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Montserrat-Light.ttf");
  font-weight: 300;
}

@font-face {
  font-family: customfont;
  src: url("./styles/fonts/Montserrat-Thin.ttf");
  font-weight: 200;
}

.my-font {
  font-family: "customfont";
}

.l-text-header {
  font-size: 64px !important;
  line-height: 1;
  @media only screen and (max-width: 800px) {
    font-size: 36px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 24px !important;
  }
}

.l-text-title {
  font-size: 48px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 800px) {
    font-size: 38px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 32px !important;
  }
}

.l-text-title-2 {
  font-size: 38px !important;
  @media only screen and (max-width: 800px) {
    font-size: 20px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 18px !important;
  }
}

.l-text-title-3 {
  font-size: 36px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 800px) {
    font-size: 30px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 24px !important;
  }
}

.l-text-title-4 {
  font-size: 48px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 800px) {
    font-size: 36px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 24px !important;
  }
}

.l-text-title-5 {
  font-size: 32px !important;
  @media only screen and (max-width: 800px) {
    font-size: 28px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 24px !important;
  }
}

.l-text-subtitle {
  font-size: 24px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 800px) {
    font-size: 18px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 16px !important;
  }
}

.l-text-subtitle-2 {
  font-size: 24px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 800px) {
    font-size: 20px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 18px !important;
  }
}

.l-text-detail {
  font-size: 18px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 800px) {
    font-size: 14px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 13px !important;
  }
}

.l-text-detail-2 {
  font-size: 16px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 800px) {
    font-size: 14px !important;
  }
  @media only screen and (max-width: 500px) {
    font-size: 13px !important;
  }
}

.l-text-description {
  font-size: 14px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 12px !important;
  }
}

.l-text-description-2 {
  font-size: 12px !important;
  // line-height: 1.8;
  @media only screen and (max-width: 500px) {
    font-size: 10px !important;
  }
}

.border-card {
  border-radius: 10px !important;
  border: 1px solid #d0d0d0 !important;
}

.active-menu {
  padding-left: 14px !important;
  border-left: 2px solid #0288d1 !important;
}

.inactive-menu {
  border-left: none;
}
</style>
